const QueryKeys = {
  list: 'streams/variables/list',
};

export default QueryKeys;
